import React from 'react';
import Interstitial from './index';

const ExternalModal = ({ trigger, url }) => {
  return (
    <Interstitial
      title='You are now leaving TakedaOncologyCopay.com,'
      subtitle='the official site for the Takeda Oncology Co-Pay Assistance Program.'
      main_content={ <p>This link will take you to another Takeda Oncology website.</p> }
      class="external-modal"
      goToHref={ url }
      goToText='Continue'
      stayBtn="Cancel"
      trigger={ trigger }
    />
  );
};

export default ExternalModal;
